import * as React from "react";
import { SmallButton } from "./SmallButton";

type EditState = "editing" | "normal";

type State = {
  editState: EditState;
};

type Props = {
  onStartEdit: () => void;
  onSave: () => void;
};

/**
 * This is the edit button seen on comments, reviews and forum topics.
 */
export class EditButton extends React.Component<Props, State> {
  state: State = {
    editState: "normal",
  };

  render(): JSX.Element {
    const isEditing = this.state.editState === "editing";

    return (
      <SmallButton
        onClick={() => {
          this.setState(
            {
              editState: isEditing ? "normal" : "editing",
            },
            () => {
              if (this.state.editState === "editing") {
                this.props.onStartEdit();
              } else {
                this.props.onSave();
              }
            },
          );
        }}
        icon={
          isEditing ? (
            <i className="fa fa-floppy-o" aria-hidden="true"></i>
          ) : (
            <i className="fa fa-pencil" aria-hidden="true"></i>
          )
        }
      >
        {isEditing ? "Save" : "Edit"}
      </SmallButton>
    );
  }
}
